import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
const initialState = {
  selectedDate: {
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
  },
};

export const dailyManageSlice = createSlice({
  name: "dailyManage",
  initialState,
  reducers: {
    setSelectedDate: (state, action) => {
      const { key, value } = action.payload;
      state.selectedDate[key] = value;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setSelectedDate } = dailyManageSlice.actions;

export default dailyManageSlice.reducer;
